import { useCallback } from 'react';
import { useDispatch } from 'store/hooks';
import { FillsGraphConfiguration } from './FillsGraphConfiguration';
import { updateFillsGraphConfiguration } from './actions';
import { useWidgetContext } from 'widgets/WidgetContext';

export const useDispatchUpdateFillsGraphConfiguration = () => {
    const { widgetKey } = useWidgetContext();
    const dispatch = useDispatch();
    return useCallback(
        (fillsGraphConfiguration: FillsGraphConfiguration) => {
            dispatch(
                updateFillsGraphConfiguration(
                    widgetKey,
                    fillsGraphConfiguration
                )
            );
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [widgetKey]
    );
};
